import { html, css, LitElement } from 'lit';
import { property } from 'lit/decorators.js';

export class SebButton extends LitElement {
  static styles = css`
    :host {
      display: block;
      color: var(--seb-text-color, #111927);
    }

    :host button {
      -webkit-text-size-adjust: 100%;
      -webkit-font-smoothing: antialiased;
      color-scheme: light;
      display: inline-flex;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: center;
      justify-content: center;
      position: relative;
      box-sizing: border-box;
      -webkit-tap-highlight-color: transparent;
      outline: 0;
      border: 0;
      margin: 0;
      cursor: pointer;
      user-select: none;
      vertical-align: middle;
      -webkit-appearance: none;
      text-decoration: none;
      font-weight: 600;
      font-family: "Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji";
      font-size: 0.875rem;
      line-height: 1.75;
      min-width: 64px;
      transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      color: var(--seb-text-color, white);
      background-color: var(--seb-primary-color, #6366F1);
      box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.08);
      border-radius: 12px;
      text-transform: none;
      padding: 8px 20px;
    }

    :host button:hover {
      filter: brightness(0.9);
    }

    :host button:active {
      filter: brightness(0.7);
    }

    :host button:disabled {
      filter: brightness(0.5) grayscale(1);
      cursor: not-allowed;
    }
  `;

  @property({ type: String }) type = 'button';

  @property({ type: Boolean }) disabled = false;

  @property() click: any;

  render() {
    return html`
      <button
        type="${this.type || 'button'}"
        ?disabled="${this.disabled}"
        @click="${this.click}"
      >
        <slot></slot>
      </button>
    `;
  }
}
